import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { roundPrice } from 'lib/pricing_utils';
import BookingActionCreator from 'action_creators/booking_request';
import PaymentForm from './payment_form';

import './index.scss';

function onlineFormTitle() {
  return (
    <div>
      <i className="af-lock" />
      Pay online now
    </div>
  );
}

export default class PaymentMethods extends React.Component {
  static displayName = 'TourPage-BookingDetails-PaymentMethods';
  static propTypes = {
    bookingRequest: PropTypes.object.isRequired,
    onlineTotal: PropTypes.string,
    cashTotal: PropTypes.string,
    loading: PropTypes.bool,
  };
  static defaultProps = {
    loading: false,
    onlineTotal: 0,
    cashTotal: 0,
  };

  payInCashClicked(e) {
    e.preventDefault();
    this.saveBookingRequest(
      Object.assign({}, this.props.bookingRequest, { paid_in_cash: true })
    );
  }

  payOnlineClicked(e) {
    e.preventDefault();
    this.saveBookingRequest(
      Object.assign({}, this.props.bookingRequest, { paid_in_cash: false })
    );
  }

  saveBookingRequest(params) {
    BookingActionCreator.save(params);
  }

  cashFormProps() {
    const actionClassName = classnames(
      'TourPage-BookingDetails-PaymentMethods-Action-Secondary ui fluid huge button',
      { loading: this.props.loading }
    );

    return {
      className: 'TourPage-BookingDetails-PaymentMethods-Cash',
      title: 'Pay in cash later',
      amount: roundPrice(this.props.cashTotal),
      hint: 'Pay cash in the local currency when you arrive at the tour',
      action: {
        onClick: this.payInCashClicked.bind(this),
        className: actionClassName,
        text: 'Pay in cash later',
      },
    };
  }

  onlineFormProps() {
    const actionClassName = classnames(
      'TourPage-BookingDetails-PaymentMethods-Action ui fluid huge button anygreen',
      { loading: this.props.loading }
    );

    return {
      className: 'TourPage-BookingDetails-PaymentMethods-Online',
      title: onlineFormTitle(),
      amount: this.onlineFormAmount(),
      hint: 'Pay easily and securely now with a credit or debit card',
      action: {
        onClick: this.payOnlineClicked.bind(this),
        className: actionClassName,
        text: 'Pay Now',
      },
    };
  }

  onlineFormAmount() {
    return (
      <div>
        <span className="amount-cash">{roundPrice(this.props.cashTotal)}</span>
        <span className="amount-online">
          {roundPrice(this.props.onlineTotal)}
        </span>
      </div>
    );
  }

  render() {
    return (
      <div className="TourPage-BookingDetails-PaymentMethods">
        <div className="TourPage-BookingDetails-PaymentMethods-Header">
          <div className="title">Choose how you'd like to pay</div>
        </div>
        <div className="TourPage-BookingDetails-PaymentMethods-Content">
          <PaymentForm {...this.cashFormProps()} />
          <div className="TourPage-BookingDetails-PaymentMethods-Bordered"></div>
          <PaymentForm {...this.onlineFormProps()} />
        </div>
      </div>
    );
  }
}
